var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "user-notes" }, [
    _c("h4", [_vm._v("授权声明书")]),
    _vm._m(0),
    _vm.$store.getters.hasAuthUser
      ? _c("p", [
          _c("span", { staticClass: "content" }, [
            _vm._v("授权人：" + _vm._s(_vm.$store.getters.authUser.username))
          ])
        ])
      : _vm._e(),
    _c("p", [
      _c("span", { staticClass: "content" }, [
        _vm._v(
          "授权日期：" + _vm._s(_vm._f("format")(new Date(), "YYYY-MM-DD"))
        )
      ])
    ]),
    _c("h4", [_vm._v("投保须知")]),
    _vm._m(1),
    _vm._m(2),
    _vm._m(3),
    _vm._m(4),
    _vm._m(5),
    _vm._m(6),
    _vm._m(7),
    _vm._m(8),
    _vm._m(9)
  ])
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("p", [
      _c("span", { staticClass: "content" }, [
        _c("b", [_vm._v("本人（包括法人及其他合法团体组织或自然人")]),
        _vm._v("已"),
        _c("b", [_vm._v("阅读并充分知晓由")]),
        _vm._v("华安财产保险股份有限公司重庆分公司提供的"),
        _c("b", [
          _vm._v("电子数据保全法律费用损失保险产品的全部保险责任和除外责任")
        ]),
        _vm._v("，在本人与 "),
        _c("b", [_vm._v("重庆易保全网络科技有限公司")]),
        _vm._v(
          "发生单笔电子数据保全的交易活动中，为更好地保障自身权益，同意并授权：\n    "
        )
      ]),
      _c("span", { staticClass: "content" }, [
        _c("b", [
          _vm._v(
            "由重庆易保全网络科技有限公司作为本人的投保人，向华安财产保险股份有限公司重庆分公司购买单笔电子数据保全法律费用损失保险 ，被保险人为本人。"
          )
        ])
      ]),
      _c("span", { staticClass: "content" }, [
        _vm._v("以上授权自授权之日起 "),
        _c("b", [_vm._v("十个工作日")]),
        _vm._v(" 内生效。")
      ])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("p", [_c("b", [_vm._v("尊敬的用户：")])])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("p", [
      _c("span", { staticClass: "content" }, [
        _vm._v(
          "首先感谢使用华安保险的电子数据保全法律费用损失保险，请在投保前认真阅读本须知："
        )
      ])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("p", [
      _c("span", { staticClass: "title" }, [_vm._v("一、保险客体 ")]),
      _c("span", { staticClass: "content" }, [
        _vm._v("  单笔保全数据，表现形式为保全备案号。")
      ])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("p", [
      _c("span", { staticClass: "title" }, [_vm._v("二、授权")]),
      _c("span", { staticClass: "content" }, [
        _vm._v(
          " 在保险单约定的等待期结束后，在本保险合同期间内，被保险人在投保人平台保全的数据，用于其作为被告、原告参与的民事诉讼、刑事自诉、行政诉讼或仲裁活动的司法举证，对于被保险人应支付的下列法律费用，保险人负责赔偿："
        )
      ]),
      _c("span", { staticClass: "content" }, [_vm._v(" （一）\t诉讼费用；")]),
      _c("span", { staticClass: "content" }, [_vm._v("（二） 仲裁费用；")]),
      _c("span", { staticClass: "content" }, [_vm._v("（三） 执行费用；")]),
      _c("span", { staticClass: "content" }, [_vm._v("（四） 司法鉴定费用；")]),
      _c("span", { staticClass: "content" }, [_vm._v("（五） 公证费用；")]),
      _c("span", { staticClass: "content" }, [
        _vm._v(" （六） 保全出证费用；")
      ]),
      _c("span", { staticClass: "content" }, [
        _vm._v("（七） 法院文书邮寄送达费用")
      ])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("p", [
      _c("span", { staticClass: "title" }, [_vm._v("四、保险期限")]),
      _c("span", { staticClass: "content" }, [
        _vm._v(
          "一年或一年的整数倍，最长不超过3年。 保险起期为用户购买本保险服务的第二天零时起，即T+1。"
        )
      ])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("p", [
      _c("span", { staticClass: "title" }, [_vm._v("五、赔偿限额")]),
      _c("span", { staticClass: "content" }, [
        _vm._v(" 累计赔偿限额RMB1万元，保险期限内赔偿次数1次。")
      ])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("p", [
      _c("span", { staticClass: "title" }, [_vm._v("六、免赔率：")]),
      _c("span", { staticClass: "content" }, [
        _vm._v("每次事故免赔率为损失金额的20%。")
      ])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("p", [
      _c("span", { staticClass: "title" }, [_vm._v("七、等待期")]),
      _c("span", { staticClass: "content" }, [
        _vm._v(
          "30天（指自投保人投保时起至保险合同生效时止之间的时间段，由投保人与保险人协商确定，并在保险单中载明，在等待期内保险人不承担赔偿责任。）"
        )
      ])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("p", [
      _c("span", { staticClass: "title" }, [_vm._v("八、除外责任")]),
      _c("span", { staticClass: "content" }, [
        _vm._v(
          "（一）根据《中华人民共和国法律援助条例》的规定，被保险人可获得法律援助的，保险人对该部分律师代理费用不负责赔偿； "
        )
      ]),
      _c("span", { staticClass: "content" }, [
        _vm._v(
          "（二）根据《诉讼费用交纳办法》规定，人民法院准予减免被保险人的诉讼费用的，对于减免部分，保险人不负责赔偿； "
        )
      ]),
      _c("span", { staticClass: "content" }, [
        _vm._v(
          "（三）被保险人在投保前已经发生的或可以合理预见的诉讼、仲裁案件所产生的一切法律费用； "
        )
      ]),
      _c("span", { staticClass: "content" }, [
        _vm._v("（四）等待期内发生的各类诉讼、仲裁案件引起的一切法律费用；")
      ]),
      _c("span", { staticClass: "content" }, [_vm._v("（五）免赔额。")]),
      _c("span", { staticClass: "content" }, [
        _vm._v(
          "（六）被保险人在投保人平台以外做公证、司法鉴定所产生费用或对非保险主体做公证、司法鉴定所产生的费用；"
        )
      ]),
      _c("span", { staticClass: "content" }, [
        _vm._v("（七）被保险人过失、疏忽、故意或恶意申请保全导致的司法纠纷；")
      ]),
      _c("span", { staticClass: "content" }, [
        _vm._v("（八）被保险人的非法及违法行为；")
      ]),
      _c("span", { staticClass: "content" }, [
        _vm._v("（九）被保险人与投保人之间的司法纠纷；")
      ]),
      _c("span", { staticClass: "content" }, [
        _vm._v(
          "（十）保险人或投保人举证与保险客体无关的司法纠纷，并被法院认可的；"
        )
      ]),
      _c("span", { staticClass: "content" }, [
        _vm._v("（十一）保全数据在保全前非真实合法，或有既往司法纠纷；")
      ]),
      _c("span", { staticClass: "content" }, [
        _vm._v(
          "（十二） 其他不属于本保险责任范围内的损失、费用和责任，保险人不负责赔偿。 "
        )
      ])
    ])
  }
]
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-0812009a", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-0812009a","hasScoped":true,"transformToRequire":{"video":"src","source":"src","object":"src","embed":"src"},"preserveWhitespace":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./pages/insure/userNotes.vue
// module id = EgyW
// module chunks = 225